import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAPI, useStore } from 'global'
import { apiError } from 'utils'
import { Button, ApplyDeviceConfigButton, openModal, closeModal } from 'components'
import { useMe } from 'contexts'
import { OpenBeforeAlarmDuration, OpenAlarmDuration } from 'enums'
import LockConfigsEdit from './lockConfigsEdit'
import './styles.scss'

export default function LockConfigs(props) {
  const { t } = useTranslation(null, { useSuspense: false })
  const { storeID } = props
  const { store, setMerchandizeConfig, setStayUnlockedConfig } = useStore()
  const { me } = useMe()
  const api = useAPI()
  const [lockConfigs, setLockConfigs] = useState()

  useEffect(() => {
    if (!storeID) return
    api.getOrgConfigs().then(orgConfs => {
      const oc = orgConfs.find(c => c.nodeType == 'sleepy')
      if (!oc) return
      api.getStoreConfigs(storeID).then(confs => {
        let storeConfs = { orgDefault: oc }
        for (let c of confs) {
          if (c.nodeType != 'sleepy') return
          if (c.name == 'Default') storeConfs.storeDefault = c
          if (c.name == 'Merchandize') storeConfs.merchandize = c
          if (c.name == 'Stay Unlocked') storeConfs.stayUnlocked = c
        }
        setLockConfigs(storeConfs)
      }).catch(apiError)
    }).catch(apiError)
  }, [storeID])

  const onUpdated = newConfigs => {
    if (newConfigs) {
      setLockConfigs(newConfigs)
      if (store.id == storeID) {
        setMerchandizeConfig(newConfigs.merchandize)
        setStayUnlockedConfig(newConfigs.stayUnlocked)
      }
    }
    closeModal()
  }
  const onEdit = () => openModal(<LockConfigsEdit lockConfigs={lockConfigs} storeID={storeID} onFinish={onUpdated} />)

  const configFields = (label, c) => {
    const beforeKey = OpenBeforeAlarmDuration(c.durationBeforeAlarm)
    const durKey = OpenAlarmDuration(c.alarmDuration)
    return (
      <>
        <h4>{label}</h4>
        <p className='small subtitle'>{t('deviceConfig.openBeforeAlarmDur')}</p>
        <p>{t(`deviceConfig.${beforeKey}`)}</p>
        <p className='small subtitle'>{t('deviceConfig.openAlarmDur')}</p>
        <p>{t(`deviceConfig.${durKey}`)}</p>
      </>
    )
  }

  if (!lockConfigs) return <></>
  return (
    <div className='lock-configs-comp col'>
      <h3>{t('storeDetails.lockConfigurations')}</h3>
      {lockConfigs.storeDefault ?
        configFields(t('storeDetails.storeLockConfig'), lockConfigs.storeDefault.configurationSettings)
        : configFields(t('storeDetails.orgLockConfig'), lockConfigs.orgDefault.defaultConfiguration)
      }
      {lockConfigs.merchandize && configFields(t('storeDetails.merchandizeLockConfig'), lockConfigs.merchandize.configurationSettings)}
      {lockConfigs.stayUnlocked && configFields(t('storeDetails.stayUnlockedLockConfig'), lockConfigs.stayUnlocked.configurationSettings)}
      {me?.canEditStore && (
        <>
          <Button onClick={onEdit}>{t('storeDetails.editLockConfigs')}</Button>
          <ApplyDeviceConfigButton config={lockConfigs.merchandize} commandString={t('commands.merchandize')} />
        </>
      )}
    </div>
  )
}
